import { useMemo, useState } from "react";
import { Bell, ChevronDown, CircleHelp, Menu, Table2 } from "lucide-react";
import { Sidebar } from "@/components/Sidebar";
import { ChatView } from "@/components/ChatView";
import { AdminPanel } from "@/components/AdminPanel";
import { useReporting } from "@/hooks/use-reporting";
import { timeAgo } from "@/lib/api";
import "@/App.css";

function App() {
  const { projects, project, setProject, messages, history, health, busy, notice, ask, runReport, reset, loadProjects } = useReporting();
  const [adminOpen, setAdminOpen] = useState(false);
  const [mobileNav, setMobileNav] = useState(false);
  const liveCount = useMemo(() => projects.filter(p => p.id !== "all" && p.has_data).length, [projects]);
  const statusText = health ? (health.last_sync ? `Live · synced ${timeAgo(health.last_sync)}` : "Connected · awaiting first sync") : "Connecting…";

  return (
    <div className="app-shell">
      <Sidebar open={mobileNav} history={history} liveCount={liveCount} onClose={() => setMobileNav(false)} onNewChat={reset} onOpenAdmin={() => setAdminOpen(true)} onAsk={ask} />
      <main className="main-area">
        <header className="topbar">
          <button className="icon-btn mobile-menu" data-testid="open-navigation-button" onClick={() => setMobileNav(true)}><Menu size={19} /></button>
          <div className="breadcrumb"><span>Workspace</span><span>/</span><strong>Reporting chat</strong></div>
          <div className="top-actions">
            <span className={`live-status ${health?.last_sync ? "" : "status-warn"}`} data-testid="live-status"><i></i> {statusText}</span>
            <button className="icon-btn" data-testid="notifications-button"><Bell size={18} /></button>
            <button className="icon-btn" data-testid="help-button"><CircleHelp size={18} /></button>
          </div>
        </header>
        <section className="content-wrap">
          <div className="hero-row">
            <div>
              <div className="eyebrow"><span className="eyebrow-line"></span> Management intelligence</div>
              <h1>Ask the numbers.<br /><em>Move with clarity.</em></h1>
              <p className="hero-copy">Live figures from your project workbooks, computed in the database and explained by AI.</p>
            </div>
            <div className="project-control">
              <span className="field-label">Reporting scope</span>
              <div className="select-wrap">
                <Table2 size={16} />
                <select value={project} data-testid="project-selector" onChange={e => setProject(e.target.value)}>{projects.map(p => <option key={p.id} value={p.id}>{p.name}{p.id !== "all" && !p.has_data ? " (no data)" : ""}</option>)}</select>
                <ChevronDown size={15} />
              </div>
            </div>
          </div>
          <ChatView messages={messages} busy={busy} notice={notice} onAsk={ask} onReport={runReport} />
        </section>
      </main>
      {adminOpen && <AdminPanel projects={projects} onClose={() => setAdminOpen(false)} onProjectsChanged={loadProjects} />}
    </div>
  );
}

export default App;
